// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"ImagePlaceholder_pattern-gradient__ocpys","image":"ImagePlaceholder_image__-M8LP","fallback":"ImagePlaceholder_fallback__JdaDP"};